import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useMemo, useState } from 'react';
import { apiGifts } from '../../api/apiGifts.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

export function GiftListProfile({ userId }) {
  const axiosPrivate = useAxiosPrivate();
  const [gifts, setGifts] = useState([]);

  useEffect(() => {
    apiGifts.fetchGiftsById(axiosPrivate, undefined, userId).then(res => setGifts(res.filter(g => g.isGifted)));
  }, []);

  // Одинаковые подарки стакаются: один слайд с количеством ×N
  const stackedGifts = useMemo(() => {
    const byGift = new Map();

    gifts.forEach((g) => {
      const existing = byGift.get(g._id);
      if (existing) {
        existing.count += 1;
      } else {
        byGift.set(g._id, { ...g, count: 1 });
      }
    });

    return Array.from(byGift.values());
  }, [gifts]);

  if (gifts.length === 0) return null;

  return (
    <>
      <h1 className="font-raleway font-bold mt-6 text-white text-[18px] mb-2">Подарки</h1>
      <div>
        <Swiper modules={[]} spaceBetween={10} slidesPerView={2.2} className="w-full h-[130px]">
          {stackedGifts.map((g) => (
            <SwiperSlide
              key={g._id}
              className="relative rounded-[16px] flex justify-center items-center bg-[#FFFFFF1A]"
            >
              {g.count > 1 && (
                <span className="absolute top-[6px] right-[6px] z-10  text-white text-[18px] font-semibold rounded-full min-w-[20px] h-[18px] px-[5px] flex items-center justify-center font-raleway">
                  ×{g.count}
                </span>
              )}
              <img src={g.imageUrl} alt={g.title} className="w-full h-full p-5" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
